var navigatePicker = function navigatePicker(picker, keycode, selectedDate) {
  var baseDate = selectedDate || moment().startOf('day').toDate();
  switch (keycode) {
    case 37:
      // Left
      picker.setDate(moment(baseDate).subtract(1, 'day').toDate());
      break;
    case 39:
      // Right
      picker.setDate(moment(baseDate).add(1, 'day').toDate());
      break;
    case 38:
      // Up
      picker.setDate(moment(baseDate).subtract(1, 'week').toDate());
      break;
    case 40:
      // Down
      picker.setDate(moment(baseDate).add(1, 'week').toDate());
      break;
    case 13: // Enter
    case 27:
      // Esc
      picker.hide();
      break;
    default:
      // No action for other keys
      break;
  }
};
var initializeDateField = function initializeDateField(element) {
  if (typeof Pikaday === 'undefined' || typeof moment === 'undefined') return;
  var picker = new Pikaday({
    field: element,
    theme: 'clf-datepicker',
    minDate: moment().startOf('day').toDate(),
    onOpen: function onOpen() {
      var pickerInstance = this;
      var keydownHandler = function keydownHandler(e) {
        e.preventDefault();
        var selectedDate = pickerInstance.getDate();
        navigatePicker(pickerInstance, e.keyCode, selectedDate);
      };
      document.addEventListener('keydown', keydownHandler);
      element.pikadayKeydownHandler = keydownHandler;
    },
    onClose: function onClose() {
      if (element.pikadayKeydownHandler) {
        document.removeEventListener('keydown', element.pikadayKeydownHandler);
        delete element.pikadayKeydownHandler;
      }
    },
    onSelect: function onSelect() {
      var clearButton = document.getElementById('clear-start-date');
      if (clearButton) {
        clearButton.classList.remove('hide');
      }
    }
  });
  element.pikaday = picker;
};
var initializeDateFields = function initializeDateFields() {
  document.querySelectorAll('.clf-date-field').forEach(initializeDateField);
};
document.addEventListener('DOMContentLoaded', function () {
  // Initialize tooltips (Bootstrap)
  if (typeof bootstrap !== 'undefined') {
    document.querySelectorAll('[data-toggle="tooltip"]').forEach(function (el) {
      // eslint-disable-next-line no-new
      new bootstrap.Tooltip(el);
    });
  }
  initializeDateFields();

  // Scroll invalid fields into view
  var formElements = document.querySelectorAll('input, select, textarea');
  formElements.forEach(function (element) {
    element.addEventListener('invalid', function () {
      this.scrollIntoView(false);
    });
  });

  // Clear start date functionality
  var startDateEl = document.getElementById('approximate-start-date');
  var clearStartDateEl = document.getElementById('clear-start-date');
  if (clearStartDateEl && startDateEl) {
    clearStartDateEl.addEventListener('click', function (e) {
      e.preventDefault();
      if (startDateEl.pikaday) {
        startDateEl.pikaday.setDate(null);
      }
      clearStartDateEl.classList.add('hide');
    });

    // Hide clear button if no date value
    if (!startDateEl.value) {
      clearStartDateEl.classList.add('hide');
    }
  }

  // Initialize dirty forms (if library is available)
  if (typeof $ !== 'undefined' && $.fn.dirtyForms) {
    $('form.project-form').dirtyForms({
      dialog: {
        title: 'You have unsaved changes',
        message: 'If you leave without saving, you will lose your changes.',
        proceedButtonClass: 'clf-proceed-btn'
      }
    });
  }

  // Banner toggle close
  var bannerCloseButtons = document.querySelectorAll('.banner-toggle-close');
  bannerCloseButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      var consultantReferralBannerShares = document.getElementById('consultant-referral-banner-shares-show');
      var consultantReferralBannerProjects = document.getElementById('consultant-referral-banner-projects-show');
      var sharesShowTitle = document.querySelector('.shares-show-title');
      if (consultantReferralBannerShares) {
        consultantReferralBannerShares.style.display = 'none';
      }
      if (consultantReferralBannerProjects) {
        consultantReferralBannerProjects.style.display = 'none';
      }
      if (sharesShowTitle) {
        sharesShowTitle.classList.add('no-referral');
      }
    });
  });
});